export const environment = {
  production: true,
  // Live production backend on cPanel (direct index.php routing prevents LiteSpeed 404 CORS failures)
  apiUrl: 'https://gomsolutions.com.ng/joybackend/index.php'
};
